import { gql } from '@apollo/client';
import { Button, VStack } from '@chakra-ui/react';
import { DocumentNode } from 'graphql';
import * as React from 'react';

import { Comments_PostFragment } from './graphql-types/Comments_PostFragment';

import { IExpandProps } from '../../hooks/useExpand';
import { TopLevelComment } from './components/TopLevelComment';

const EXPAND_INCREMENT = 5;

export const Comments: React.FC<{
  post: Comments_PostFragment;
  expandProps: IExpandProps;
}> & {
  postFragment: DocumentNode;
} = ({ post, expandProps }) => {
  const { numHidden, expand, startIndex } = expandProps;

  if (post.comments.length === 0) {
    return null;
  }

  return (
    <>
      {numHidden > 0 && (
        <Button
          variant="link"
          onClick={() => expand(EXPAND_INCREMENT)}
          colorScheme="black"
        >
          Show More Comments
        </Button>
      )}
      <VStack spacing="2" align="start" width="full">
        {post.comments.slice(startIndex).map((comment) => (
          <TopLevelComment key={comment._id} comment={comment} />
        ))}
      </VStack>
    </>
  );
};

Comments.postFragment = gql`
  fragment Comments_PostFragment on PostV2 {
    _id
    comments {
      _id
      ...TopLevelComment_CommentFragment
    }
  }
  ${TopLevelComment.commentFragment}
`;
